import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { Input } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

class ReportConstructorTitleEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportId: props.report !== undefined && props.report !== null ? props.report.id : null,
      title: props.report !== undefined && props.report !== null ? props.report.title : null,
      isTitleEdit: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { updateCustomReportTitleDataState } = this.props;

    if (prevProps.updateCustomReportTitleDataState === states.REQUEST && updateCustomReportTitleDataState === states.READY) {
      this.setState({ isTitleEdit: false });
    }
  }

  onUpdateTitle() {
    const { onUpdateCustomReportTitle } = this.props;
    const { title, reportId } = this.state;

    onUpdateCustomReportTitle({ title, id: reportId });
  }

  onChangeTitle(title) {
    this.setState({ title });
  }

  render() {
    const { title, isTitleEdit } = this.state;
    const { updateCustomReportTitleDataState } = this.props;

    return (
      <div className={styles.reportCustomTitleEditContainer}>
        {updateCustomReportTitleDataState === states.REQUEST ? (
          <Preloader />
        ) : isTitleEdit ? (
          <div className={styles.reportTitleEditing}>
            <Input
              name="customReportTitle"
              type="text"
              onChange={(e) => {
                this.onChangeTitle(e.target.value);
              }}
              placeholder="Наименование пользовательского отчета"
              defaultValue={title}
              fullWidth={true}
            />

            <TooltipWrapper title={"Сохранить наименование отчета"} position="top">
              <div>
                <SaveIcon
                  fontSize="small"
                  className={styles.reportTitleEditButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onUpdateTitle();
                  }}
                />
              </div>
            </TooltipWrapper>
          </div>
        ) : (
          <div className={styles.reportTitle}>
            {title}
            <div
              className={styles.reportTitleEditButton}
              onClick={(e) => {
                e.stopPropagation();
                this.setState({ isTitleEdit: true });
              }}
            >
              <TooltipWrapper title={"Изменить наименование отчета"} position="top">
                <EditIcon fontSize="inherit" />
              </TooltipWrapper>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withCustomReport(React.memo(ReportConstructorTitleEdit));
